import { render, staticRenderFns } from "./TaxView.vue?vue&type=template&id=66747221&"
import script from "./TaxView.vue?vue&type=script&lang=js&"
export * from "./TaxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports